import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import PlacesAutocomplete from 'react-places-autocomplete';
import Input from '@material-ui/core/Input';
import ListItemText from '@material-ui/core/ListItemText';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import { Element } from 'react-scroll';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import NativeSelect from '@material-ui/core/NativeSelect';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Hidden from '@material-ui/core/Hidden'

import {
  trainingOrderings,
  languages,
  trainingAttendanceTypes,
} from '../../../shared/Mappings';
import {
  createProfileRoute,
  getOrderingNameByCode,
  prettifyOscarDate,
} from '../../../shared/Helpers';
import { GOOGLE_MAPS_NAV_LINK } from '../../../shared/Constants';
import niaMarker from '../../../static/img/icons/location_icon.svg';
import calendarIcon from '../../../static/img/icons/calendar_icon.svg';

const drawerWidth = 420;
const drawerWidthMobile = 330;

const styles = theme => ({
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 18px',
    ...theme.mixins.toolbar,
  },
  drawerPaper: {
    overflowX: 'hidden',
    width: drawerWidthMobile,
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
    },
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: 0,
  },
  locationSearchInput: {
    padding: theme.spacing(2),
  },
  list: {
    // overflow: 'scroll',
    overflowX: 'hidden',
    paddingTop: 0,
  },
  listDivider: {
    marginBottom: theme.spacing(),
  },
  autocompleteDropdownContainer: {
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    padding: 0,
  },
  suggestionItem: {
    backgroundColor: '#ffffff',
    cursor: 'pointer',
  },
  suggestionItemActive: {
    backgroundColor: '#fafafa',
    cursor: 'pointer',
  },
  activeListItem: {
    padding: 0,
    margin: 0,
    boxShadow: '0px 0px 10px grey',
    // backgroundColor: theme.palette.action.selected,
  },
  infoText: {
    padding: theme.spacing(3),
    paddingTop: 0,
    whiteSpace: 'normal',
    wordWrap: 'break-word',
  },
  column2: {
    paddingRight: theme.spacing(2),
    paddingTop: 0,
  },
  resultsTitle: {
    letterSpacing: 1,
  },
  listItem: {
    padding: 0,
    margin: 0,
  },
  classTimesHeader: {
    textTransform: 'uppercase',
    paddingBottom: theme.spacing(),
  },
  classTimesText: {
    fontSize: 12,
  },
  niaMarker: {
    verticalAlign: 'text-bottom',
    height: 22,
    width: 22,
  },
  locationAddress: {
    fontSize: 12,
  },
  locationTitle: {
    color: 'black',
    textTransform: 'uppercase',
    letterSpacing: '0.7px',
  },
  directionsLink: {
    textDecoration: 'none',
    textTransform: 'none',
    fontSize: 12,
    color: theme.palette.blue,
    '&:visited': {
      color: theme.palette.blue,
    },
  },
  flex: {
    display: 'flex',
    justifyContent: 'center',
  },
  withText: {
    paddingTop: 2,
    marginRight: theme.spacing(),
    marginLeft: theme.spacing(),
    color: theme.palette.primary.dark,
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  locationLink: {
    textDecoration: 'none',
  },
  listItemActions: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
  },
  detailsButton: {
    fontSize: 11,
    marginRight: theme.spacing(),
    marginLeft: theme.spacing(),
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
    '&:visited': {
      color: 'inherit',
    },
  },
  toolbarDivider: {
    // backgroundColor: 'rgba(0, 0, 0, 0.42)',
  },
  nextPageContainer: {
    textAlign: 'center',
  },
  loadingSpinnerContainer: {
    display: 'flex',
    height: '100%',
    marginTop: theme.spacing(4),
    justifyContent: 'center',
  },
  subtitle: {
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: 3,
    paddingLeft: theme.spacing(),
    paddingTop: theme.spacing(),
    paddingRight: theme.spacing(),
  },
  eventImg: {
    marginBottom: 4,
    height: 22,
    width: 22,
    verticalAlign: 'text-bottom',
    marginRight: theme.spacing(),
  },
  trainerLinkP: {
    textAlign: 'center',
    fontSize: '0.9rem',
    paddingBottom: theme.spacing(),
  },
  trainerLink: {
    fontWeight: 'bold',
    textDecoration: 'none',
    color: theme.palette.primary.dark,
    '&:visited': {
      color: theme.palette.primary.dark,
    },
    textTransform: 'uppercase',
    letterSpacing: 2,
  },
  formControl: {
    marginBottom: theme.spacing(2),
  },
  upperFormControl: {
    marginBottom: theme.spacing(),
  },
  dateFieldLeft: {
    marginRight: theme.spacing(),
  },
  dateFieldRight: {
    marginLeft: theme.spacing(),
  },
  dateGroup: {
    display: 'inline-block',
    paddingTop: theme.spacing(),
  },
  buttonContainer: {
    paddingTop: theme.spacing(),
    textAlign: 'right',
    paddingRight: theme.spacing(2),
  },
  selectedPageSize: {
    backgroundColor: theme.palette.primary.dark,
  },
  pageSizeFormControl: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  expanded: {
    '&$expanded': {
      margin: '0',
    },
  },
  content: {
    '&$content': {
      justifyContent: 'flex-end',
    },
  },
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
  },
  formPadding: {
    padding: theme.spacing(2),
  },
  query: {
    backgroundColor: 'white',
    paddingBottom: theme.spacing(),
  },
  gridContainer: {
    flexWrap: 'nowrap',
  },
});

class MapSearchPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
    this.isActiveClass = this.isActiveClass.bind(this);
  }

  isActiveClass(id) {
    const { active } = this.props;
    if (id === active) {
      return true;
    }
    return false;
  }

  render() {
    const {
      classes,
      open,
      handleDrawerClose,
      handleDrawerOpen,
      address,
      listItems,
      handleLocationChange,
      handleLocationSelect,
      onResultClick,
      checked,
      handleViewToggle,
      loading,
      pageLoading,
      getNextPage,
      morePagesAvailable,
      currentEventType,
      attendanceType,
      handleAttendanceTypeChange,
      handleResetSearch,
      language,
      handleLanguageChange,
      ordering,
      handleOrderChange,
      pageSize,
      handlePageSizeChange,
      expanded,
      handleAccordionChange,
      eventTypes,
      handleEventTypeChange,
      trainer,
      trainers,
      handleTrainerChange,
      startDate,
      handleStartDateChange,
      endDate,
      handleEndDateChange,
      handlePopupOpen,
      queryHasChanged,
      handleMakeQuery,
    } = this.props;

    const renderLocationTitle = (item) => {
      if (item.distance === undefined || item.distance === null) {
        return item.location.title;
      }
      return item.location.title + ' (' + item.distance.substring(0, 3) + 'mi)';
    };

    const renderButton = (event) => {
      if (event.event_type.depends_on_text !== '') {
        return (
          <Button
            onClick={e => handlePopupOpen(e, event.event_type.depends_on_text, event.event_type.depends_on_checkbox, event.link)}
            variant="contained"
            color="secondary"
            className={classes.detailsButton}
          >
            Learn More
          </Button>
        );
      }
      return (
        <Button target="_blank" variant="contained" color="secondary" className={classes.detailsButton} href={event.link}>Learn More</Button>
      );
    };

    const drawer = (
      <React.Fragment>
        <div className={classes.toolbarIcon}>
          <Grid component="label" container alignItems="center" spacing={0}>
            <Grid item>
              <Typography>List View</Typography>
            </Grid>
            <Grid item>
              {/* VIEW */}
              <Switch
                checked={checked}
                onChange={e => handleViewToggle(e)}
                value="checked"
                color="default"
              />
            </Grid>
            <Grid item>
              <Typography>Map View</Typography>
            </Grid>
          </Grid>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider className={classes.toolbarDivider} color="textPrimary" />

        {/* SEARCH */}
        {!loading && (
          <PlacesAutocomplete
            value={address}
            onChange={e => handleLocationChange(e)}
            onSelect={e => handleLocationSelect(e)}
          >
            {({
              getInputProps,
              suggestions,
              getSuggestionItemProps,
              autocompleteloading,
            }) => (
              <div>
                <Input
                  {...getInputProps({
                    fullWidth: true,
                    placeholder: 'Search Address, City, State or Zip',
                    className: classes.locationSearchInput,
                    endAdornment: <InputAdornment position="end"><SearchIcon /></InputAdornment>,
                  })}
                />
                <List className={classes.autocompleteDropdownContainer}>
                  {autocompleteloading && <div key="loading">Loading...</div>}
                  {suggestions.map((suggestion) => {
                    const className = suggestion.active
                      ? classes.suggestionItemActive
                      : classes.suggestionItem;
                    return (
                      <ListItem
                        key={suggestion.placeId}
                        {...getSuggestionItemProps(suggestion, { className })}
                      >
                        <ListItemText key={suggestion.placeId}>{suggestion.description}</ListItemText>
                      </ListItem>
                    );
                  })}
                </List>
              </div>
            )}
          </PlacesAutocomplete>
        )}
        {/* ACCORDION */}
        <Accordion expanded={expanded} onChange={handleAccordionChange} classes={{ expanded: classes.expanded }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            classes={{ content: classes.content }}
          >
            <Typography><strong>Filters</strong></Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <div className={classes.formPadding}>
              {/* ATTENDANCE RADIOS */}
              <Tooltip placement="top-start" title="Only in-person trainings allowed in map view">
                <FormControl disabled fullWidth component="fieldset" className={classes.upperFormControl}>
                  <FormLabel color="secondary" component="legend">Online/In-Person</FormLabel>
                  <RadioGroup row aria-label="attendance" name="attendance" value={attendanceType} onChange={handleAttendanceTypeChange}>
                    {trainingAttendanceTypes.map(at => (<FormControlLabel key={at.code} value={at.code} control={<Radio color="secondary" />} label={at.name} />))}
                  </RadioGroup>
                </FormControl>
              </Tooltip>
              {/* TRAINER */}
              <FormControl fullWidth className={classes.formControl}>
                <FormLabel color="secondary" htmlFor="trainer-native-helper">Trainer</FormLabel>
                <NativeSelect
                  fullWidth
                  value={trainer}
                  onChange={e => handleTrainerChange(e)}
                  input={<Input name="trainer" id="trainer-native-helper" style={{ marginTop: 8 }} />}
                >
                  {trainers.map(t => <option key={t.id} value={t.id}>{t.first_name + ' ' + t.last_name}</option>)}
                </NativeSelect>
              </FormControl>
              {/* EVENT TYPE */}
              <FormControl fullWidth className={classes.formControl}>
                <FormLabel color="secondary" htmlFor="belt-level-native-helper">Training Type</FormLabel>
                <NativeSelect
                  fullWidth
                  value={currentEventType}
                  onChange={e => handleEventTypeChange(e)}
                  input={<Input name="belt level" id="belt-level-native-helper" style={{ marginTop: 8 }} />}
                >
                  {eventTypes.map((et) => {
                    if (et.public) {
                      if (et.extra) {
                        return (<option key={et.id} value={et.id}>{et.level + ' - ' + et.extra}</option>);
                      }
                      return (<option key={et.id} value={et.id}>{et.level}</option>);
                    }
                    return null;
                  })}
                </NativeSelect>
              </FormControl>
              {/* STARTS BETWEEN DATES */}
              <FormControl fullWidth className={classes.formControl}>
                <FormLabel component="legend">Starts Between Dates</FormLabel>
                <FormGroup row className={classes.dateGroup}>
                  <TextField
                    id="start date"
                    label="Range Start"
                    type="date"
                    value={startDate}
                    className={classes.dateFieldLeft}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={e => handleStartDateChange(e)}
                  />
                  <TextField
                    id="end date"
                    label="Range End"
                    type="date"
                    value={endDate}
                    className={classes.dateFieldRight}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={e => handleEndDateChange(e)}
                  />
                </FormGroup>
              </FormControl>
              {/* LANGUAGE */}
              <FormControl fullWidth className={classes.formControl}>
                <FormLabel color="secondary" htmlFor="class-type-native-helper">Language</FormLabel>
                <Select
                  native
                  fullWidth
                  value={language}
                  onChange={e => handleLanguageChange(e)}
                  input={<Input name="class type" id="class-type-native-helper" style={{ marginTop: 8 }} />}
                >
                  {languages.map(currentLanguage => <option key={currentLanguage.code} value={currentLanguage.code}>{currentLanguage.name}</option>)}
                </Select>
              </FormControl>
              {/* SORT */}
              <Tooltip placement="top-start" title="Only sort by distance allowed in map view">
                <FormControl fullWidth component="fieldset" className={classes.formControl} disabled>
                  <FormLabel color="secondary" component="legend">Sort By</FormLabel>
                  <RadioGroup row aria-label="attendance" name="attendance" value={ordering} onChange={handleOrderChange}>
                    {trainingOrderings.map(theOrdering => <FormControlLabel key={theOrdering.code} value={theOrdering.code} control={<Radio color="secondary" />} label={theOrdering.name} />)}
                  </RadioGroup>
                </FormControl>
              </Tooltip>
              {/* PAGE SIZE */}
              <FormControl fullWidth className={classes.pageSizeFormControl}>
                <FormLabel color="secondary" htmlFor="class-type-native-helper">Show&nbsp;</FormLabel>
                <ButtonGroup variant="text" color="secondary" aria-label="text primary button group">
                  <Button onClick={() => handlePageSizeChange('20')} className={pageSize === '20' ? classes.selectedPageSize : classes.pageSizeOption}>20</Button>
                  <Button onClick={() => handlePageSizeChange('50')} className={pageSize === '50' ? classes.selectedPageSize : classes.pageSizeOption}>50</Button>
                  {/*<Button onClick={() => handlePageSizeChange('100')} className={pageSize === '100' ? classes.selectedPageSize : classes.pageSizeOption}>100</Button>*/}
                  {/*<Button onClick={() => handlePageSizeChange('all')} className={pageSize === 'all' ? classes.selectedPageSize : classes.pageSizeOption}>All</Button>*/}
                </ButtonGroup>
              </FormControl>
            </div>
          </AccordionDetails>
        </Accordion>
        <div className={classes.buttonContainer}>
          <Button className={classes.button} onClick={handleResetSearch}>Reset</Button>
          <Button className={classes.button} variant="contained" color="secondary" disabled={loading || !queryHasChanged} onClick={handleMakeQuery}>Search</Button>
        </div>
        {/* SEARCH RESULTS */}
        <Typography color="textSecondary" align="center" variant="body2" className={classes.resultsTitle} gutterBottom>{'Sorted by ' + getOrderingNameByCode(ordering)}</Typography>
        <Divider />
        {!loading
          ? (
            <Element id="containerElement" name="containerElement" className={classes.list}>
              {listItems.map(item => (
                <Element className="element" key={item.id} name={'scrollto' + item.id}>
                  <ListItem
                    className={this.isActiveClass(item.id) ? classes.activeListItem : classes.listItem}
                  >
                    <Grid container direction="column" className={classes.gridContainer}>
                      <Typography variant="h5" className={classes.subtitle}>
                        <img src={item.event_type.img} className={classes.eventImg} alt="class type icon" />
                        {item.event_type.level}
                      </Typography>
                      <Typography variant="h5" className={classes.trainerLinkP}>
                        <Link target="_blank" rel="noopener noreferrer" className={classes.trainerLink} to={createProfileRoute(item.user.username)}>
                          {item.user.first_name + ' ' + item.user.last_name}
                        </Link>
                      </Typography>
                      <Grid item>
                        <Grid container direction="row">
                          <Grid className={classes.infoText} item xs={12}>
                            {/* ADDRESS */}
                            {item.location
                              ? (
                                <Typography color="textSecondary" className={classes.classTimesHeader}>
                                  <Link to={'/location/' + item.location.id} className={classes.link}>
                                    <img alt="nia marker" className={classes.niaMarker} src={niaMarker} />
                                    {renderLocationTitle(item)}
                                  </Link>
                                  <span className={classes.locationAddress}>{' - ' + item.location.address + ' '}</span>
                                  <span color="secondary"><a target="_blank" rel="noopener noreferrer" className={classes.directionsLink} href={GOOGLE_MAPS_NAV_LINK + encodeURIComponent(item.location.address)}>Get Directions</a></span>
                                </Typography>
                              )
                              : (
                                <Typography color="textSecondary" className={classes.classTimesHeader}>
                                  <img alt="nia marker" className={classes.niaMarker} src={niaMarker} />
                                  No Location
                                </Typography>
                              )
                            }
                            {/* CLASS TIMES COLUMN */}
                            <Typography color="textSecondary" className={classes.classTimesHeader}>
                              <img alt="calendar" className={classes.niaMarker} src={calendarIcon} />
                              {' ' + prettifyOscarDate(item.start_date) + ' - ' + prettifyOscarDate(item.end_date)}
                            </Typography>
                          </Grid>
                        </Grid>
                        {/* BUTTONS */}
                        <div className={classes.listItemActions}>
                          <Button variant="contained" color="primary" className={classes.detailsButton} onClick={() => onResultClick(item.id)}>Show</Button>
                          {renderButton(item)}
                        </div>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <Divider />
                </Element>
              ))}
              <div className={classes.nextPageContainer}>
                {pageLoading
                  ? (
                    <CircularProgress color="secondary" />
                  )
                  : (
                    <Button
                      onClick={getNextPage}
                      disabled={!morePagesAvailable}
                    >
                      {listItems.length ? 'Load More' : 'No Nearby Trainings'}
                    </Button>
                  )
                }
              </div>
            </Element>
          )
          : (
            <div className={classes.loadingSpinnerContainer}>
              <CircularProgress color="secondary" />
            </div>
          )
        }
      </React.Fragment>
    );

    return (
      <React.Fragment>
        <Hidden lgUp>
          <SwipeableDrawer
            classes={{
              paper: classNames(classes.drawerPaper, !open && classes.drawerPaperClose),
            }}
            variant="temporary"
            open={open}
            onOpen={handleDrawerOpen}
            onClose={handleDrawerClose}
          >
            {drawer}
          </SwipeableDrawer>
        </Hidden>
        <Hidden smDown>
          <Drawer
            classes={{
              paper: classNames(classes.drawerPaper, !open && classes.drawerPaperClose),
            }}
            variant="permanent"
            open={open}
          >
            {drawer}
          </Drawer>
        </Hidden>
      </React.Fragment>
    );
  }
}

MapSearchPanel.propTypes = {
  handleLocationSelect: PropTypes.func.isRequired,
  handleLocationChange: PropTypes.func.isRequired,
  address: PropTypes.string.isRequired,
  handleDrawerClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  checked: PropTypes.bool.isRequired,
  handleViewToggle: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  listItems: PropTypes.array.isRequired,
  onResultClick: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  morePagesAvailable: PropTypes.bool.isRequired,
  getNextPage: PropTypes.func.isRequired,
  pageLoading: PropTypes.bool.isRequired,
  attendanceType: PropTypes.string.isRequired,
  handleAttendanceTypeChange: PropTypes.func.isRequired,
  handleResetSearch: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  handleLanguageChange: PropTypes.func.isRequired,
  ordering: PropTypes.string.isRequired,
  handleOrderChange: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
  handleAccordionChange: PropTypes.func.isRequired,
  pageSize: PropTypes.string.isRequired,
  handlePageSizeChange: PropTypes.func.isRequired,
  eventType: PropTypes.number.isRequired,
  eventTypes: PropTypes.array.isRequired,
  handleEventTypeChange: PropTypes.func.isRequired,
  trainer: PropTypes.number.isRequired,
  trainers: PropTypes.array.isRequired,
  handleTrainerChange: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  handleStartDateChange: PropTypes.func.isRequired,
  endDate: PropTypes.string.isRequired,
  handleEndDateChange: PropTypes.func.isRequired,
  handlePopupOpen: PropTypes.func.isRequired,
  queryHasChanged: PropTypes.bool.isRequired,
};

export default withStyles(styles)(MapSearchPanel);
